const messages = {
    buttons: {
        productBrochures: "Objevit",
    },
    index: {
        title: "INFORMACE O PRODUKTU",
        description: "Stáhněte si zde nejnovější brožury a letáky našich pneumatik Bridgestone a Firestone.",
        categories: {
            productBrochures: {
                title: "Produktové brožury",
                description: "Brožury řad pneumatik Bridgestone a Firestone",
            },
            bDrive: {
              title: "Obrázky produktů",
              description: "Aktuální obrázky najdete ke stažení na našem portálu B-DRIVE.",
            },
        
          kickback: {
            description: "Den teilnehmenden Unternehmen werden Kickback-Gebühren auf Basis der übermittelten Umsatzzahlen gutgeschrieben.",
          },}
    }
};

export default {
    messages,
};

